// const BASE = 'http://localhost:90/reactfaturatasarimi/api/';
const BASE = 'http://E.1yerde.com/_faturaTasarimiApi/';
// const BASE = 'http://fatura-tasarimcisi.berkaygure.com/api/';
// const BASE = 'http://localhost/berkaygure.com/fatura-tasarimcisi/api/';
export const INIT  = BASE + '?action=init';
export const CREATE  = BASE + '?action=create';
export const OPEN_APP  = BASE + '?action=open';
export const PREVIEW  = BASE + '?action=preview';
export const SHOW_PREVIEW  = BASE + '?action=show';
export const SAVE  = BASE + '?action=save';


// WEBPACK FOOTER //
// ./src/api/index.js